import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-1a1954e2"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "the_end"
};

var _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div data-v-1a1954e2><div class=\"starsec\" data-v-1a1954e2></div><div class=\"starthird\" data-v-1a1954e2></div><div class=\"starfourth\" data-v-1a1954e2></div><div class=\"starfifth\" data-v-1a1954e2></div></div><div class=\"lamp__wrap\" data-v-1a1954e2><div class=\"lamp\" data-v-1a1954e2><div class=\"cable\" data-v-1a1954e2></div><div class=\"cover\" data-v-1a1954e2></div><div class=\"in-cover\" data-v-1a1954e2><div class=\"bulb\" data-v-1a1954e2></div></div><div class=\"light\" data-v-1a1954e2></div></div></div>", 2);

var _hoisted_4 = {
  class: "error"
};
var _hoisted_5 = {
  class: "error__content"
};
var _hoisted_6 = {
  class: "error__message message"
};
var _hoisted_7 = {
  class: "message__title"
};
var _hoisted_8 = {
  class: "message__text"
};
var _hoisted_9 = {
  class: "error__nav e-nav"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("h1", _hoisted_7, _toDisplayString(_ctx.title), 1), _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.text), 1)]), _createElementVNode("div", _hoisted_9, [_createElementVNode("span", {
    class: "e-nav__link",
    onClick: _cache[0] || (_cache[0] = function () {
      return $setup.callBack && $setup.callBack.apply($setup, arguments);
    })
  })])])])])]);
}